import React from 'react';

const SvgTag = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12.636 3l-9.081 9.082c-.74.74-.74 1.939 0 2.679l5.684 5.684c.74.74 1.94.74 2.68 0L21 11.364V3h-8.364zm5.048 1.895a1.422 1.422 0 110 2.843 1.422 1.422 0 010-2.843z" />
  </svg>
);

export default SvgTag;
